<template>
  <v-layout class="pl-4 excerpt-wrapper">
    <v-flex class="py-1 xs11" grow>
      <h1 v-if="excerptType == 'textExcerpt'" class="excerpt title" v-html="exerptHtml"></h1>
      <excerpt-image
        v-else-if="excerptType == 'imageExcerpt'"
        :fileRef="excerptData.imageRef"
        :downloadUrl="excerptData.downloadUrl"
      ></excerpt-image>
    </v-flex>
    <!-- <v-flex v-if="variant != 'hide-image'">
      <v-progress-circular
        v-if="
          excerptData.verificationStatus == 'pending' ||
            excerptData.verificationStatus == 'verifying'
        "
        indeterminate
        color="grey lighten-2"
        size="15"
      ></v-progress-circular>
      <v-btn icon small v-else class="ma-0" @click.stop="openModal" style="display: inline-block;">
        <v-icon v-if="excerptData.verificationStatus == 'pass'" small color="grey lighten-1">
          image
        </v-icon>
        <v-icon v-else small color="grey lighten-2">help</v-icon>
      </v-btn>
      <v-menu
        v-model="imageModal"
        v-if="imageModal"
        absolute
        offset-x
        offset-overflow
        left
        :nudge-top="50"
      >
        <v-card v-if="imageModal">
          <excerpt-image
            v-if="excerptData.verifyImageRef"
            :fileRef="excerptData.verifyImageRef"
          ></excerpt-image>
          <v-btn v-else @click="verifyAgain" flat>Retry fetching excerpt</v-btn>
        </v-card>
      </v-menu>
    </v-flex> -->
  </v-layout>
</template>

<script>
import { mapActions } from 'vuex';
import ExcerptImage from './ExcerptImage.vue';

export default {
  props: ['excerpt', 'variant', 'highlight'], // vairant can be full or hide-image
  components: { ExcerptImage },
  data() {
    return {
      imageModal: false,
      x: 0,
      y: 0
    };
  },
  computed: {
    excerptData() {
      return this.excerpt.content.widgetData;
    },
    excerptType() {
      return this.excerpt && this.excerpt.content ? this.excerpt.content.widgetType : '';
    },
    exerptHtml() {
      //  escape html
      const excerpt = this.excerptData.excerpt
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
      let result = excerpt;
      if (this.highlight) {
        var index = excerpt.toLowerCase().indexOf(this.highlight.toLowerCase());
        if (index >= 0) {
          result = '';
          if (index > 0) {
            result += excerpt.substring(0, index);
          }
          result +=
            "<span class='highlight orange--text'>" +
            excerpt.substring(index, index + this.highlight.length) +
            '</span>' +
            excerpt.substring(index + this.highlight.length);
        }
      }
      return result;
    }
  },
  methods: {
    ...mapActions('context/notes', ['verifyExcerpt']),
    openModal(e) {
      e.preventDefault();
      this.imageModal = false;
      this.x = this.excerpt.fileRef ? e.clientX - 500 : e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.imageModal = true;
      });
    },
    verifyAgain() {
      const exData = {
        excerpt: this.excerpt.excerpt,
        url: this.excerpt.url,
        resourceId: this.note.id,
        pageType: this.pageType,
        pageId: this.note.page,
        retry: true
      };
      console.log(exData);
      // this.verifyExcerpt(exData);
    }
    // async setFilePath() {
    //   this.loadingImage = true;
    //   let url;
    //   try {
    //     const fileRef = fb.storage.ref().child(this.excerpt.fileRef);
    //     url = await fileRef.getDownloadURL();
    //   } catch {
    //     url = false;
    //   }

    //   this.loadingImage = false;
    //   this.filePath = url;
    // }
  }
};
</script>

<style scoped>
.excerpt.title {
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif !important;
  font-size: 16px !important;
  font-weight: 100;
  line-height: 1.3 !important;
  letter-spacing: 0.02em !important;
}

.excerpt-wrapper {
  background: #fbfbfb;
  border: 1px solid rgb(232, 232, 232);
  border-left: 5px solid rgb(212, 211, 211);
  border-radius: 0 8px 8px 0;
}
</style>
